import React, { useState, useEffect } from "react";
import {
    Card,
    Box,
    Typography,
    TextField,
    Button,
    MenuItem,
} from "@mui/material";
import signInBanner1 from '../../assets/signin_banner.jpg';
import signInBanner2 from '../../assets/signin_banner1.jpeg';
import signInBanner3 from '../../assets/signin_banner-2.jpeg';
import { useNavigate } from "react-router-dom";
import { ReactComponent as LockIcon } from '../../assets/svg/lock.svg';
import { ReactComponent as TimerIcon } from '../../assets/svg/timer.svg';
import LoginIcon from '@mui/icons-material/Login';
import '../../css/App.css';
/* const countries = [
    { code: "+91", label: "India" },
    { code: "+1", label: "USA" },
    { code: "+44", label: "UK" },
    // Add more as needed
]; */

const VerifyOTPSignin = () => {

    const navigate = useNavigate();
    const [useMobileLogin, setUseMobileLogin] = useState(false);
    const sidebanner = [signInBanner1, signInBanner2, signInBanner3];
    const [bannercurrentIndex, setBannerCurrentIndex] = useState(0);


    useEffect(() => {
        const interval = setInterval(() => {
            setBannerCurrentIndex((prev) => (prev + 1) % sidebanner.length);
        }, 3000);

        return () => clearInterval(interval);
    }, []);

    /* const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");

    const [mobileNumber, setMobileNumber] = useState("");
    const [countryCode, setCountryCode] = useState("+91");

    const handleSubmit = () => {
        if (useMobileLogin) {
            console.log("Logging in with:", countryCode + mobileNumber);
        } else {
            console.log("Logging in with:", email, password);
        }
    }; */

    return (
        <Box className="primary-box">
            <Box className="secondary-box">
                <Card className="auth-card"
                    sx={{
                        p: 3
                    }}
                >
                    {/* Icon */}
                    <Box className="auth-lock"
                        sx={{
                            mx: "auto",
                            mb: 2,
                        }}
                    >
                        <LockIcon />
                    </Box>

                    {/* Title */}
                    <Typography
                        variant="h5"
                        sx={{ fontWeight: 600, mb: 2, textAlign: "center" }}
                    >
                        Verify your phone
                    </Typography>

                    <Typography
                        variant="h6"
                        sx={{ fontWeight: 'lighter', mb: 2, textAlign: "center" }}
                    >
                        Enter the 4-digit code sent to +91 2121212121
                    </Typography>

                    <>
                        {/* otp field */}
                        <Box sx={{ display: "flex", gap: 1, mb: 2 }}>
                            {[0, 1, 2, 3].map((_, index) => (
                                <TextField
                                    key={index}
                                    inputProps={{
                                        maxLength: 1,
                                        style: { textAlign: "center", fontSize: "1.2rem" },
                                    }}
                                    size="small"
                                    sx={{ width: "25%" }}
                                />
                            ))}
                        </Box>
                    </>

                    {/* Submit Button */}
                    <Button
                        fullWidth
                        variant="contained"
                        // onClick={handleSubmit}
                        sx={{
                            textTransform: "none",
                            fontWeight: "bold",
                            backgroundColor: "#C32032",
                            mb: 1,
                        }}
                    >
                        Verify & Login<LoginIcon />
                    </Button>

                    {/* resend otp */}
                    <Box sx={{ display: 'flex', gap: "4px", justifyContent: 'center' }}>
                        <Typography
                            variant="body2"
                            sx={{
                                textAlign: "center",
                                color: "#000",
                            }}
                        >
                            Don't receive the code?
                        </Typography>
                        <Typography
                            variant="body2"
                            sx={{
                                textAlign: "center",
                                cursor: "pointer",
                                textDecoration: "underline",
                                color: "#C32032",
                            }}
                        >
                            Resend OTP
                        </Typography>
                    </Box>

                    <Box sx={{ marginTop: '2%' }}>
                        <Typography
                            variant="body2"
                            className="otp-timer-text"
                            sx={{
                                gap: 1,
                            }}
                        >
                            <TimerIcon fontSize="small" />
                            OTP valid for 10:00 minutes
                        </Typography>
                    </Box>

                </Card>
            </Box>
        </Box>
    );
};

export default VerifyOTPSignin;